import React, { memo } from 'react';
import { Sparkle16Filled } from '@fluentui/react-icons';
import AssistantResponseContent from '../structured/AssistantResponseContent';
import { contextModeLabel } from '../../../utils/askAiChatMeta';
import { formatMessageTime } from '../../Journal/Analysis/analysisUtils';
import markdownStyles from '../markdown/richMarkdown.module.css';
import styles from '../askAi.module.css';
import streamingStyles from './streaming.module.css';

function StreamingAssistantMessage({ streamState, contextMode, className = '' }) {
    const {
        phase,
        displayContent,
        completedBlocks,
        pendingMarkdown,
        responseBlocks,
        isComplete,
    } = streamState || {};

    const isPending = phase === 'pending';
    const isStreaming = phase === 'streaming' || (phase === 'pending' && !displayContent);

    return (
        <div className={`${styles.messageBlock} ${streamingStyles.streamingMessage}`}>
            <div className={styles.avatarAi} aria-hidden>
                <Sparkle16Filled />
            </div>
            <div className={styles.messageContent}>
                <div className={styles.messageMeta}>
                    <span className={styles.messageName}>Lens</span>
                    <span className={styles.messageTime}>{formatMessageTime(new Date().toISOString())}</span>
                    <span className={styles.contextPill}>{contextModeLabel(contextMode)}</span>
                </div>
                {isPending && !displayContent ? (
                    <div className={streamingStyles.streamingPending} role="status" aria-live="polite">
                        <span>Thinking</span>
                        <span className={markdownStyles.streamingCursor} aria-hidden />
                    </div>
                ) : (
                    <AssistantResponseContent
                        answer={displayContent}
                        responseBlocks={responseBlocks}
                        completedBlocks={completedBlocks}
                        pendingMarkdown={pendingMarkdown}
                        streaming={isStreaming && !isComplete}
                        streamingComplete={isComplete}
                        citations={[]}
                        chunks={[]}
                        citationScope=""
                        className={`${styles.assistantMarkdown} ${className}`.trim()}
                    />
                )}
            </div>
        </div>
    );
}

export default memo(StreamingAssistantMessage);
